export const PATHS = {
  LOGIN: "/Login",
  ERROR: "/ErrorPage",
};

export const PORTAL_PATHS = {
  RESERVAR_TURNO: "/portal/Reservar turno",
  HORARIOS: "/portal/Horarios",
  DATOS: "/portal/Datos",
  TURNOS: "/portal/Turnos",
  ESTUDIOS: "/portal/Estudios",
  RESERVAR_TURNOS_IMAGENES: "/portal/Reservar turnos imágenes",
};
